import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

/**
 * Service to trigger opening the My Drafts modal from ChallengeHomeComponent
 * when ChallengeCreateComponent is loaded via router (avoids direct ViewChild dependency).
 */
@Injectable({ providedIn: 'root' })
export class ChallengeDraftsService {
  private openDrafts$ = new Subject<void>();

  /** Emits when My Drafts button is clicked. ChallengeCreateComponent subscribes and opens the modal. */
  readonly onOpenDrafts = this.openDrafts$.asObservable();

  /** Call when My Drafts button is clicked. */
  requestOpenDrafts(): void {
    this.openDrafts$.next();
  }
}
